import * as React from 'react';
import classnames from 'classnames';
import { Button } from '@nackle/paper';
import { FloppyDisk } from '@nackle/icons/dist/react-es/linear';

export default class SaveButton extends React.Component {
    static defaultProps = {
        disabled: false,
        className: 'save-button',
        id: 'saveButton',
        text: 'Save',
        closeClickableOverlay: true
    };
    state = {
        saving: false
    };
    save = () => {
        this.setState( { saving: true } );
        this.props
            .save()
            .then( () => {
                this.setState( { saving: false } );
                if ( this.props.closeClickableOverlay ) {
                    document.getElementById( 'clickableOverlayClose' ).click();
                }
            } )
            .catch( () => this.setState( { saving: false } ) );
    };
    render() {
        const { className, id, disabled } = this.props;
        const saving = this.state.saving;
        return (
            <Button
                disabled={ disabled }
                loading={ saving }
                type="primary"
                icon={ <FloppyDisk /> }
                className={ classnames( [ 'form-button', className ] ) }
                id={ id }
                onClick={ this.save }
            >
                { this.props.text }
            </Button>
        );
    }
}
